export enum LoggerType {
	DEBUG = 'debug',
	INFO = 'info',
	LOG = 'log',
	WARN = 'warn',
	ERROR = 'error',
	TABLE = 'table'
}
